// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 1000px;
  height: 100%;
  max-height: 600px;
  padding: 20px;
  /* overflow: auto; */
  background-color: rgb(164, 164, 164);
  border-radius: 5px;
  border-color: black;
  border-width: 1px;
}

.Modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
}

.Modal-close {
  font-size: 20px;
  font-weight: bold;
  color: gray;
  cursor: pointer;
}

.buttons-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 3rem;
}

.data-button-container {
  display: flex;
  flex-direction: row;
  margin-top: 1rem;
}

.buttons-container .btn,
.data-button-container .btn {
  width: 200px;
  height: 48px;
  margin-right: 10px;
}

.choice-container {
  position: relative;
  margin-top: 10px;
}

.choice-container button {
  margin: 10px;
}

.choice-container > div {
  display: flex;
  justify-content: center;
}

.selection {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.clear-data {
  display: flex;
  align-items: center;
}

.sample-container {
  display: flex;
  flex-direction: row;
  text-align: center;
}

.clear-button {
  text-align: center;
  border-radius: 0.5rem;
  border-width: 0.5px;
  margin-left: -1.5rem;
  margin-top: -0.2rem;
}

.sample-clear-button {
  width: 100%;
}

.acquisition-data-customized-content .chooseData-button {
  width: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.acquisition-data-customized-content .org-btn {
  width: 100%;
  min-height: 38px;
  font-size: 13px;
}

.acquisition-data-customized-content .sample-clear-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.modal-header-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.chooseData-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.loadData-button {
  display: flex;
  justify-content: stretch;
  width: 100%;
  margin-top: 0;
}

.mntPath-container {
  width: 200px;
  white-space: wrap;
}

.acquisition-data-page {
  min-height: 100vh;
}

.acquisition-data-main .datasets {
  width: 100%;
  margin: 0;
}

.acquisition-data-customized-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.acquisition-data-customized-content .dataset-info {
  width: 100%;
}

.dataset-info-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 10px;
}

.dataset-info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 8px;
  border: 1px solid #eef2f7;
  border-radius: 10px;
  background: #f8fafc;
}

.dataset-info-item span {
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.dataset-info-item strong {
  color: #0f172a;
  font-size: 13px;
  font-weight: 700;
}

.acquisition-data-customized-content .dataset-info .org-btn {
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/AcquisitionDataPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,oBAAoB;EACpB,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".Modal-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.Modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  max-width: 1000px;\n  height: 100%;\n  max-height: 600px;\n  padding: 20px;\n  /* overflow: auto; */\n  background-color: rgb(164, 164, 164);\n  border-radius: 5px;\n  border-color: black;\n  border-width: 1px;\n}\n\n.Modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 10px;\n}\n\n.Modal-close {\n  font-size: 20px;\n  font-weight: bold;\n  color: gray;\n  cursor: pointer;\n}\n\n.buttons-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-top: 3rem;\n}\n\n.data-button-container {\n  display: flex;\n  flex-direction: row;\n  margin-top: 1rem;\n}\n\n.buttons-container .btn,\n.data-button-container .btn {\n  width: 200px;\n  height: 48px;\n  margin-right: 10px;\n}\n\n.choice-container {\n  position: relative;\n  margin-top: 10px;\n}\n\n.choice-container button {\n  margin: 10px;\n}\n\n.choice-container > div {\n  display: flex;\n  justify-content: center;\n}\n\n.selection {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.clear-data {\n  display: flex;\n  align-items: center;\n}\n\n.sample-container {\n  display: flex;\n  flex-direction: row;\n  text-align: center;\n}\n\n.clear-button {\n  text-align: center;\n  border-radius: 0.5rem;\n  border-width: 0.5px;\n  margin-left: -1.5rem;\n  margin-top: -0.2rem;\n}\n\n.sample-clear-button {\n  width: 100%;\n}\n\n.acquisition-data-customized-content .chooseData-button {\n  width: 100%;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.acquisition-data-customized-content .org-btn {\n  width: 100%;\n  min-height: 38px;\n  font-size: 13px;\n}\n\n.acquisition-data-customized-content .sample-clear-button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.modal-header-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.chooseData-button {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n\n.loadData-button {\n  display: flex;\n  justify-content: stretch;\n  width: 100%;\n  margin-top: 0;\n}\n\n.mntPath-container {\n  width: 200px;\n  white-space: wrap;\n}\n\n.acquisition-data-page {\n  min-height: 100vh;\n}\n\n.acquisition-data-main .datasets {\n  width: 100%;\n  margin: 0;\n}\n\n.acquisition-data-customized-content {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n.acquisition-data-customized-content .dataset-info {\n  width: 100%;\n}\n\n.dataset-info-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.dataset-info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 10px 8px;\n  border: 1px solid #eef2f7;\n  border-radius: 10px;\n  background: #f8fafc;\n}\n\n.dataset-info-item span {\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.dataset-info-item strong {\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.acquisition-data-customized-content .dataset-info .org-btn {\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
